<section class="full-height research-page">
    <ng-container *ngIf="isLoading">
        <div id="floatingCirclesG" [ngClass]="'floatingCirclesG-busy'">
            <div class="f_circleG" id="frotateG_01"></div>
            <div class="f_circleG" id="frotateG_02"></div>
            <div class="f_circleG" id="frotateG_03"></div>
            <div class="f_circleG" id="frotateG_04"></div>
            <div class="f_circleG" id="frotateG_05"></div>
            <div class="f_circleG" id="frotateG_06"></div>
            <div class="f_circleG" id="frotateG_07"></div>
            <div class="f_circleG" id="frotateG_08"></div>
        </div>
    </ng-container>

    <div class="control-panel-page">

        <!-- HEADER -->
        <div class="row">
            <div class="col-12">
                <div class="app-header markup-tool-app-header qr-tool-app-header">
                    <div class="top-bar">
                        <div class="top-bar-brand markup-tool-top-bar-brand qr-tool-top-bar-brand">
                            <a id="brandLogo" [routerLink]="['/']">
                                <div class="navigation-logo"></div>
                            </a>
                        </div>
                        <div class="top-bar-name markup-tool-portal-name qr-scanner-portal-name">
                            <div class="portal-name markup-tool-portal-name qr-scanner-portal-name">QR Code</div>
                        </div>
                        <div class="control-panel-close markup-tool-close qr-scanner-close">
                            <button type="button" class="research-button" (click)="closeScanner()">
                                <i class="fas fa-times fa-top-alignment"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- SCANNER CAMERA -->
        <div class="qr-scanner-container">
            <zxing-scanner #scanner
                           [torch]="torchEnabled"
                           [device]="currentDevice"
                           [tryHarder]="true"
                           [formats]="formatsEnabled"
                           (deviceChange)="onDeviceChange($event)"
                           (torchCompatible)="onTorchCompatible($event)"
                           [autostart]="false"
                           class="zxing-camera">
            </zxing-scanner>
        </div>

        <!-- TOOLBAR -->
        <div class="row">
            <div class="col-12">
                <div class="app-footer markup-tool-footer-1">
                    <div id="branded-background" class="research-block-order control-panel-toolbar qr-code-control-panel-toolbar">
                        <div class="qr-code-toolbar qr-code-toolbar-select-padding qr-code-toolbar-select-float" [ngClass]="{'qr-code-toolbar-select-fullwidth': isMozillaBrowser}">
                            <ng-select name="selectedDevice" id="selectedDevice" [ngClass]="{'has-value': selectedDevice}" [(ngModel)]="selectedDevice" [clearable]="false" [searchable]="false"  [disabled]="isStreamInitializing" (change)="onDeviceSelectChange($event)">
                                <ng-option *ngFor="let device of normalisedDevices" [value]="device.device.deviceId">
                                    {{ device.normalisedLabel }}
                                </ng-option>
                            </ng-select>
                            <label for="selectedDevice">Current device</label>
                        </div>
                        <div *ngIf="!isMozillaBrowser" class="qr-code-toolbar text-align-right qr-code-toolbar-button-padding qr-code-toolbar-button-float qr-code-toolbar-button-top-padding">
                            <span placement="top" ngbTooltip="Toggle torch" triggers="hover">
                                <button type="button" title="Flashlight" id="btnTorch" (click)="toggleTorch()" class="research-button research-toolbar-button" [ngClass]="torchAvailable && !isStreamInitializing ? 'research-button' : 'research-button-inactive'">
                                    <i class="fa-solid fa-top-alignment" [ngClass]="torchAvailable ? 'fa-bolt' : 'fa-bolt-slash'"></i>
                                </button>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
